import React, { useContext, useRef, useState } from 'react';
import { Line } from 'react-chartjs-2';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Button, Col, message, Row, Modal } from 'antd'; // Added Modal import
import { UserContext } from '../../../contexts/UserContext';
import SaveDataButton from '../ActionsButtons/SaveDataButton';
import WearTrendChart from './WearTrendChart';
import WearSummaryTable from './WearSummaryTable';

import coverImage from '../Tabs/images/coveer-image.jpg';
import disclaimer from '../Tabs/images/disclaimer.png';
import contact from '../Tabs/images/contact.png';
import logo from '../Tabs/images/logo.png';
import emptyHeaderImage from '../Tabs/images/empty-header.png';
import fullLogo from '../Tabs/images/full-logo.png';
import footerText from '../Tabs/images/footer-text.png';

import { insertMastersheet, uploadPdfApi } from '../../../utils/api'; // Added uploadPdf API
import { logOutUser } from '../../../utils/auth';

const ChartPDFExporter = ({ chartData, options, inspectionData, 
  recentSummary = [], handleRowsChange, dataByColumn, wearRows }) => {
  const chartRefs = useRef({});
  const wearTrendRef = useRef(null); // Ref for WearTrendChart
  const summaryTableRef = useRef(null); // Ref for WearSummaryTable
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useContext(UserContext);
  const [isModalVisible, setIsModalVisible] = useState(false); // State for modal visibility



//===================calculate mill avalabitiy for lifter
  const firstObject = Object.values(dataByColumn)[0];
  console.log("firstObject", firstObject); // { runningHours: 120 }
  const installDateLifter = new Date(firstObject.installationDateLifter);
  const installDatePlate= new Date(firstObject.installationDatePlate);
  const inspectionDate = new Date(inspectionData.inspection_date);

  // Calculate elapsed time in hours
  const elapsedMsLifter = inspectionDate - installDateLifter;
  const elapsedHoursLifter = elapsedMsLifter / (1000 * 60 * 60);

 const elapsedMsPlate= inspectionDate - installDatePlate;
  const elapsedHoursPlate = elapsedMsPlate / (1000 * 60 * 60);

  // Calculate milAvLifter
  const milAvLifter = (Number(firstObject.totalRunningHoursLifter) / elapsedHoursLifter) * 100;
  console.log("milAvLifter", milAvLifter);
 const milAvPlate = (Number(firstObject.totalRunningHoursPlate) / elapsedHoursPlate) * 100;
  console.log("milAvPlate", milAvPlate);

  const [wearTrend, setWearTrend] = useState(false);

  const handleSaveData = async () => {
    setIsModalVisible(false); // Close modal after confirmation
    setIsLoading(true);

    try {
      console.log("Json payload=============")
      console.log({ chartData, inspectionData, wearRows })
      const result = await insertMastersheet({ chartData, inspectionData, wear_summary: wearRows, dataByColumn});

      showToast(result.data.message || 'Data saved successfully!', 'success');
      
      // Generate PDF
      const pdf = await generatePdf();
      const pdfBlob = pdf.output('blob');
      console.log('PDF size:', pdfBlob.size / 1024, 'KB');


      // Upload PDF to server
      await uploadPdf(pdfBlob, inspectionData?.equipment || 0,result.data.id);
      
      // Trigger download for client
      const url = window.URL.createObjectURL(pdfBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `inspection_${inspectionData?.equipment_no || 'default'}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);  
      setIsLoading(false);
      // Redirect after download
      window.location.href = '/dashboard/master-tab';
    } catch (error) {
      showToast(`Failed to save data: ${error?.response?.data?.message || error.message}`, 'error');
      if (error?.response?.status === 401) {
        logOutUser();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const showConfirmModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const generatePdf = async () => {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const chartSize = 150; // Square size in mm for PDF
    const chartX = (pageWidth - chartSize) / 2;
    const margin = 12;
    const usableW = pageWidth - margin * 2;

    try {
      const coverImageBase64 = await pathToBase64(coverImage);
      const coverImg = await loadImage(coverImageBase64);
      const imgRatio = coverImg.width / coverImg.height;
      let imgW = pageWidth - margin * 2;
      let imgH = imgW / imgRatio;
      if (imgH > pageHeight - margin * 2) {
        imgH = pageHeight - margin * 2;
        imgW = imgH * imgRatio;
      }
      const imgX = (pageWidth - imgW) / 2;
      const imgY = (pageHeight - imgH) / 2;
      pdf.addImage(coverImg, 'JPEG', imgX, imgY, imgW, imgH);
      console.log('Cover image added to first page');
    } catch (error) {
      console.error('Failed to load cover image:', error.message);
      pdf.setFontSize(14);
      pdf.text('Cover Image Unavailable', margin, 20);
    }

    // 1️⃣ Render Inspection Data Table
    let yOffset = 215;
    pdf.setFontSize(12);
    pdf.text('Inspection Details', 15, yOffset);    
    pdf.setFontSize(8);
    yOffset += 5;
    const inspectionRows = Object.entries(inspectionData || {}).map(([key, value]) => ({
      field: key,
      value: String(value),
    }));
    const excludesArray = [
      'feed_size',
      'inspected_by',
      'isNewEntry',
      'product_size',
      'rpm',
      'unq_equipment_no',
      'liner_type',
      'ore',
      'top_ball_size',
      'equipment',
      'data_by_column',
      'notes'
    ];
    inspectionRows.forEach(({ field, value }) => {
      if (!excludesArray.includes(field)) {
        pdf.text(`${formatFieldLabel(field)}:`, 15, yOffset);
        pdf.text(value ?? '', 70, yOffset); // Align values to the right
        yOffset += 6; 
      }
    });

    //2. =============== Disclaimer
    try {
      pdf.addPage();
      const disclaimerBase64 = await pathToBase64(disclaimer);
      const disclaimerImg = await loadImage(disclaimerBase64);
      const imgRatio = disclaimerImg.width / disclaimerImg.height;
      let imgW = pageWidth - margin * 2;
      let imgH = imgW / imgRatio;
      if (imgH > pageHeight - margin * 2) {
        imgH = pageHeight - margin * 2;
        imgW = imgH * imgRatio;
      }
      const imgX = (pageWidth - imgW) / 2;
      const imgY = (pageHeight - imgH) / 2;
      pdf.addImage(disclaimerImg, 'JPEG', imgX, imgY, imgW, imgH);
      console.log('Disclaimer image added to page');
    } catch (error) {
      console.error('Failed to load disclaimer image:', error.message);
      pdf.setFontSize(14);
      pdf.text('Disclaimer Image Unavailable', margin, 20);
    }
    //3. Current Details & Forecast
     // Render Wear Summary Table
    if (summaryTableRef.current) {
      pdf.addPage();  
      await addLogoToPage(pdf, emptyHeaderImage,'Current Details & Forecast');
      //======== current details
        const onlyshow = [
            // 'diameter',
            // 'length_',
            'equipment_no',         
            'ore',
            'feed_size',    
            'product_size', 
            'top_ball_size',    
            'rpm',
        ];
        let yOffsetforCast= 35
        pdf.setFontSize(8);
        pdf.setTextColor('black');
        pdf.text(`Equipment size:`, 20, yOffsetforCast);
        pdf.text(`${inspectionData.diameter}x${inspectionData.length_}:`, 70, yOffsetforCast);
        yOffsetforCast += 5
        inspectionRows.forEach(({ field, value }) => {
          if (onlyshow.includes(field)) 
          {
            if(field ==='feed_size')
              pdf.text(`${formatFieldLabel(field)} [F80/mm]:`, 20, yOffsetforCast);
            else if(field ==='product_size')
              pdf.text(`${formatFieldLabel(field)} [P80/mm]:`, 20, yOffsetforCast);
           else if(field ==='top_ball_size')
              pdf.text(`${formatFieldLabel(field)} [mm]:`, 20, yOffsetforCast);
            else
              pdf.text(`${formatFieldLabel(field)}:`, 20, yOffsetforCast);

            pdf.text(value ?? '', 70, yOffsetforCast); // Align values to the right
            yOffsetforCast += 5; 
          }
        });
       
          //===================Current Mill availability

        pdf.text(`Current Mill availability(Lifter) :`, 20, yOffsetforCast);
        pdf.text(milAvLifter.toFixed(2)+"%" || '', 70, yOffsetforCast); // Align values to the right
        yOffsetforCast += 5; 

        pdf.text(`Current Mill availability(Plate) :`, 20, yOffsetforCast);
        pdf.text(milAvPlate.toFixed(2)+"%" || '', 70, yOffsetforCast); // Align values to the right
        yOffsetforCast += 5; 





      //========= summary
      const summaryTableCanvas = await html2canvas(summaryTableRef.current, { scale: 1, useCORS: true });
      const imgData = summaryTableCanvas.toDataURL('image/png');
      const img = new Image();
      img.src = imgData;
      await new Promise(resolve => { img.onload = resolve; });
      const ratio = img.width / img.height || 1;
      let imgW = usableW;
      let imgH = imgW / ratio;
      const maxH = pageHeight - 40;
      if (imgH > maxH) {
        const scale = maxH / imgH;
        imgH = maxH;
        imgW = imgW * scale;
      }
      pdf.addImage(imgData, 'JPEG', margin, 80, imgW, imgH);
      const Ftext = `* “This Analysis is based on height drop at standard distance from leading lifter bar edge.”*`
        pdf.setFontSize(8);
        pdf.setTextColor('black');
        pdf.text(Ftext, 40, pageHeight - 20);
    }



    // 4 Wear Profile & Render Initial Charts
    const initialKeys = Object.keys(chartData);
    for (let i = 0; i < initialKeys.length; i++) {      
      const key = initialKeys[i];
      const chartElement = chartRefs.current[key];

      if (chartElement) {
        const canvas = await html2canvas(chartElement, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL('image/jpeg', 0.9);
        
        if (i > 0 || (wearTrendRef.current || summaryTableRef.current)) {
          pdf.addPage();    
          await addLogoToPage(pdf, emptyHeaderImage,'Wear Profile ' + key.toUpperCase());      
        }
        const yStart = i === 0 ? yOffset : 30;
        pdf.addImage(imgData, 'JPEG', chartX, 30, chartSize, chartSize);
        
      }
    }

    // 5 Render Wear Trend Chart
    const initialKeysWear = Object.keys(wearTrend);
    for (let i = 0; i < initialKeysWear.length; i++) {      
      const key = initialKeysWear[i];
      const chartElement = wearTrendRef.current[key];

      if (chartElement) {
        const canvas = await html2canvas(chartElement, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL('image/jpeg', 0.9);
        
        if (i > 0 || (wearTrendRef.current || summaryTableRef.current)) {
          pdf.addPage();    
          await addLogoToPage(pdf, emptyHeaderImage,"Wear Trend "+key);               
        }
        const yStart = i === 0 ? yOffset : 30;    
        pdf.addImage(imgData, 'JPEG', chartX, 30, chartSize, chartSize/2);
      }
    }

   


    if (inspectionData?.notes) {
        try {
          pdf.addPage();
          pdf.setFontSize(16);
          pdf.setTextColor('black');
          pdf.text('Notes', margin, 20); // Title

          pdf.setFontSize(12);
          pdf.setTextColor('gray');

          // Wrap long notes into lines
          const wrappedText = pdf.splitTextToSize(inspectionData.notes, 180); // 180 = max width
          pdf.text(wrappedText, margin, 30); // Start below title
        } catch (error) {
          console.error('Failed to load Notes:', error.message);
          pdf.addPage();
          pdf.setFontSize(14);
          pdf.setTextColor('red');
          pdf.text('Notes Unavailable', margin, 20);
        }
      }


    //=============== Contact Us
    try {
      pdf.addPage();
      const contactBase64 = await pathToBase64(contact);
      const contactImg = await loadImage(contactBase64);
      const imgRatio = contactImg.width / contactImg.height;
      let imgW = pageWidth - margin * 2;
      let imgH = imgW / imgRatio;
      if (imgH > pageHeight - margin * 2) {
        imgH = pageHeight - margin * 2;
        imgW = imgH * imgRatio;
      }
      const imgX = (pageWidth - imgW) / 2;
      const imgY = (pageHeight - imgH) / 2;
      pdf.addImage(contactImg, 'JPEG', imgX, imgY, imgW, imgH);
      console.log('Contact image added to page');
    } catch (error) {
      console.error('Failed to load contact image:', error.message);
      pdf.setFontSize(14);
      pdf.text('Contact Image Unavailable', margin, 20);
    }
    // 6️⃣ Add Logo to Top-Right Corner of All Pages
    try {
      if (logo) {      
        const totalPages = pdf.getNumberOfPages();
        for (let i = 2; i < totalPages; i++) {
          pdf.setPage(i);
          //await addLogoToPage(pdf, logo);
        }
        console.log('Logo added to top-left corner of all pages');
      } else {
        console.warn('No logo provided');
      }
    } catch (error) {
      console.error('Failed to add logo to pages:', error.message);
    }

    return pdf; // Return the jsPDF instance
  };

  const uploadPdf = async (pdfBlob, equipmentId,customer_inspection_id) => {
    const formData = new FormData();
    const fileName = `inspection_${equipmentId}_${customer_inspection_id}_${Date.now()}_${Math.floor(Math.random() * 10000)}.pdf`;    
    formData.append('pdf', pdfBlob,fileName);
    formData.append('equipment_id', equipmentId); // Optional: Send equipment ID if needed by API
    formData.append('customer_inspection_id', customer_inspection_id); 
    try {
      const response = await uploadPdfApi(formData);
      console.log('PDF uploaded successfully:', response.data);
      showToast('PDF uploaded successfully!', 'success');
    } catch (error) {
      console.error('Failed to upload PDF:', error);
      showToast(`Failed to upload PDF: ${error?.response?.data?.message || error.message}`, 'error');
    }
  };

  console.log('inspectionData:', inspectionData);
  const loadImage = (base64Data) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64Data;
      img.onload = () => {
        console.log('Base64 image loaded successfully');
        resolve(img);
      };
      img.onerror = (event) => {
        console.error('Failed to load base64 image:', event);
        reject(new Error('Failed to load base64 image'));
      };
    });
  };

  const loadImageWithTimeout = (url, timeout = 10000) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.crossOrigin = 'Anonymous';

      const timeoutId = setTimeout(() => {
        console.warn(`Image loading timed out: ${url}`);
        reject(new Error(`Image loading timed out after ${timeout / 1000} seconds`));
      }, timeout);

      img.onload = () => {
        clearTimeout(timeoutId);
        console.log(`Image loaded successfully: ${url}`);
        resolve(img);
      };
      img.onerror = (event) => {
        clearTimeout(timeoutId);
        console.error(`Image failed to load: ${url}`, event);
        reject(new Error(`Failed to load image: ${url}`));
      };
      img.onabort = () => {
        clearTimeout(timeoutId);
        console.error(`Image load aborted: ${url}`);
        reject(new Error(`Image load aborted: ${url}`));
      };
    });
  };

  async function pathToBase64(path) {
    if (!path) return null;
    try {
      const res = await fetch(path, { mode: 'cors' });
      if (!res.ok) throw new Error(`Failed to fetch image: ${res.status}`);
      const blob = await res.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.error('pathToBase64 error', err);
      return null;
    }
  }

  const addLogoToPage = async (pdf, logo, heading='') => {
    const logoBase64 = await pathToBase64(logo);
    const logoImage = await loadImage(logoBase64);

    if (!logoImage) return;
    try {
      const logoWidth = 200;
      const logoHeight = 30;
      const logoX = 5;
      const logoY = 0;
      pdf.addImage(logoImage, 'JPEG', logoX, logoY, logoWidth-5, logoHeight-5);
      // Add heading to the right of the logo
      const textX = logoHeight; // 5mm gap
      const textY = logoHeight - 10 // vertically centered-ish

      pdf.setFontSize(12);
      pdf.setTextColor('white');
      pdf.text(heading, textX, textY);

      //=footer text
      const logoBase64Footer = await pathToBase64(footerText);
      const logoImageFooter = await loadImage(logoBase64Footer);
      const pageHeight = pdf.internal.pageSize.getHeight();
      pdf.addImage(logoImageFooter, 'JPEG', logoX, pageHeight-15, logoWidth, 15);

      
      console.log('Logo added to top-right corner');
    } catch (error) {
      console.error('Failed to add logo to page:', error.message);
    }
  };

 

  function formatFieldLabel(key) {
    if (!key) return '';
    const s = String(key).replace(/_/g, ' ').trim();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  return (
    <div>
      <div className="charts-container">
        {Object.keys(chartData).map((columnKey) => (
          <div
            key={columnKey}
            className="chart-card"
            ref={(el) => (chartRefs.current[columnKey] = el)}
            style={{
              width: '500px',
              height: '500px',
              padding: '20px',
              boxSizing: 'border-box',
              background: '#fff',
              border: '1px solid #ccc',
              marginBottom: '40px',
            }}
          >
            <Line
              data={chartData[columnKey]}
              options={{
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio: 1,
                layout: { padding: { top: 28, bottom: 28, left: 28, right: 28 } },
                scales: {
                  x: {
                    type: 'linear',
                    min: 0,
                    max: 500,
                    ticks: { stepSize: 100, color: '#888' },
                    title: { display: true, text: 'Width' },
                    grid: { color: '#d3d3d3', lineWidth: 0.7 },
                  },
                  y: {
                    min: 0,
                    max: 500,
                    ticks: { stepSize: 100, color: '#888' },
                    title: { display: true, text: 'Height' },
                    grid: { color: '#d3d3d3', lineWidth: 0.7 },
                  },
                },
                plugins: {
                  title: {
                    display: true,
                    text: columnKey.toUpperCase(),
                    font: { size: 10, weight: 'bold' },
                  },
                },
                elements: { point: { radius: 0 } },
              }}
            />
          </div>
        ))}

        <Row>
          <Col span={24}>
            <div ref={summaryTableRef} style={{ marginBottom: '40px' }}>
              <WearSummaryTable
                data={dataByColumn}
                inspectionData={inspectionData}
                onRowsChange={handleRowsChange}
              />
            </div>
          </Col>
        </Row>

        <div ref={wearTrendRef} style={{ marginBottom: '40px' }}>
          <WearTrendChart wearTrendRef={wearTrendRef} inspectionData={inspectionData} recentSummary={recentSummary} setWearTrend={setWearTrend} />
        </div>
      </div>

      <Button
        type="primary"
        onClick={showConfirmModal} // Changed to showConfirmModal
        loading={isLoading}
        disabled={!chartData || Object.keys(chartData).length === 0}
        style={{
          position: 'fixed',
          bottom: '50px',
          right: '11%',
          zIndex: 1000,
          padding: '0 24px',
          height: '40px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        }}
      >
        Save & Export report
      </Button>

      <Modal
        title="Confirm Save & Export"
        visible={isModalVisible}
        onOk={handleSaveData}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="No"
      >
        <p>Make sure all charts are generated before exporting the report</p>
      </Modal>
    </div>
  );
};

export default ChartPDFExporter;